    <template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '1800px' }"
    :header="'PACIENTE - ' + `${paciente.paciente.nome}`"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <div class="p-col-12">
      <Fieldset legend="Dados do Paciente" class="mb-3">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-4">
            <label for="nome">Nome do Paciente</label>
            <InputText
              id="nome"
              v-model="paciente.paciente.nome"
              class="uppercase"
              disabled
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="nome">CPF</label>
            <InputText id="nome" v-model="paciente.paciente.cpf" disabled />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cns">CNS</label>
            <InputText
              id="nome"
              v-model="paciente.numeroCNSPaciente"
              disabled
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="capacity">Nome da Mãe</label>
            <InputText
              v-model="paciente.paciente.nomeMae"
              class="uppercase"
              disabled
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="capacity">Nascimento</label>
            <InputText v-model="paciente.paciente.nascimento" disabled />
          </div>
          <div class="field col-12 md:col-2">
            <label for="capacity">Raça</label>
            <InputText
              v-model="paciente.paciente.racaPaciente"
              class="uppercase"
              disabled
            />
          </div>
          <div class="field col-12 md:col-2">
            <label for="capacity">Sexo</label>
            <InputText
              v-model="paciente.paciente.sexo"
              class="uppercase"
              disabled
            />
          </div>
        </div>

        <div class="flex justify-content-end flex-wrap"></div>
      </Fieldset>
      <Toolbar class="p-mb-4">
        <template #end>
          <div
            class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between"
          >
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters['global'].value"
                placeholder="Pesquisa por campos..."
              />
            </span>
          </div>
        </template>
      </Toolbar>
      <DataTable
        :value="data"
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 20, 30]"
        rowGroupMode="rowspan"
        :filters="filters"
        groupRowsBy="tipo"
        sortMode="single"
        sortField="tipo"
        :sortOrder="1"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} registros."
        class="p-datatable-sm"
      >
        <template #empty>
          <div class="text-center">Nenhum resultado encontrado...</div>
        </template>

        <Column
          field="tipo"
          header="Tipo Solicitação"
          :reorderableColumn="false"
        >
          <template #body="slotProps">
            <p
              v-if="slotProps.data.tipo.trim().toUpperCase() === 'EXAME'"
              class="user-badge status-true"
            >
              {{ slotProps.data.tipo.trim().toUpperCase() }}
            </p>

            <p
              v-else-if="
                slotProps.data.tipo.trim().toUpperCase() === 'CONSULTA'
              "
              class="user-badge status-info"
            >
              {{ slotProps.data.tipo.trim().toUpperCase() }}
            </p>
            <p v-else class="user-badge status-staging">
              {{ slotProps.data.tipo.trim().toUpperCase() }}
            </p>
          </template>
        </Column>
        <Column field="solicitacaoId" header="N° Solicitação">
          <template #body="slotProps">
            <p style="font-weight: bold; color: #080808">
              {{ slotProps.data.solicitacaoId }}
            </p>
          </template>
        </Column>

        <Column field="data" header="Data">
          <template #body="slotProps"
            >{{ $DateTime.formatarDate(slotProps.data.data) }}
          </template>
        </Column>

        <Column field="estado" header="Situação">
          <template #body="slotProps">
            <p
              class="user-badge"
              :class="getStatusClass(slotProps.data.estado)"
            >
              {{ removerUnderscore(slotProps.data.estado) }}
            </p>
          </template>
        </Column>
        <!-- SOLICITANTE NECESSARIO VIM DO JSON -->
        <Column field="solicitante" header="Solicitante">
          <template #body="slotProps">
            <b>{{ slotProps.data.solicitante.toUpperCase() }}</b>
          </template>
        </Column>

        <Column header="Procedimento / Serviço de Rede">
          <template #body="slotProps">
            <b>{{
              slotProps.data.codigoProcedimento
                ? slotProps.data.codigoProcedimento + "  "
                : " "
            }}</b>

            <b>{{
              slotProps.data.descProcedimento
                ? slotProps.data.descProcedimento.toUpperCase()
                : " "
            }}</b>

            <b>{{
              slotProps.data.idServicoRede
                ? slotProps.data.idServicoRede + "  "
                : " "
            }}</b>

            <b>{{
              slotProps.data.descServicoRede
                ? slotProps.data.descServicoRede.toUpperCase()
                : " "
            }}</b>
          </template>
        </Column>

        <!-- SOLICITANTE NECESSARIO VIM DO JSON -->
        <Column field="centralRegulacaoResponsavel.descricao" header="Local">
          <template #body="slotProps">
            <b>{{
              slotProps.data.centralRegulacaoResponsavel.descricao.toUpperCase()
            }}</b>
          </template>
        </Column>

        <Column field="especialidade.value" header="Especialidade">
          <template #body="slotProps">
            <b>
              {{
                slotProps.data.especialidade
                  ? slotProps.data.especialidade.value.toUpperCase()
                  : "-"
              }}
            </b>
          </template>
        </Column>
        <Column field="caraterInternacao" header="Caráter">
          <template #body="slotProps">
            <b>{{
              slotProps.data.caraterInternacao
                ? slotProps.data.caraterInternacao.toUpperCase()
                : "-"
            }}</b>
          </template>
        </Column>
      </DataTable>
    </div>

    <template #footer>
      <Button
        label="Fechar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>

<script>
import { FilterMatchMode } from "primevue/api";

//Models
import Paciente from "../../models/paciente";

//Services
import PacienteService from "../../service/paciente/paciente_service";

export default {
  props: ["pacienteSelected"],
  data() {
    return {
      paciente: new Paciente(),
      pacienteService: new PacienteService(),
      data: [],
      filters: {},
    };
  },
  created() {
    this.initFilters();
  },
  mounted() {},
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.paciente.dialogPacienteView;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.paciente.dialogPacienteView = value;
      },
    },
  },
  methods: {
    hideDialog() {
      this.paciente = new Paciente();
      this.visibleDialog = false;
    },
    getData() {
      this.data = this.pacienteSelected;
      this.paciente = { ...this.pacienteSelected[0] };
      this.paciente.paciente.nascimento = this.$DateTime.formatarDate(
        this.paciente.paciente.nascimento
      );
    },
    removerUnderscore(texto) {
      if (!texto) return ""; // Evita erro se for null ou undefined
      return texto.replace(/_/g, " ");
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    getStatusClass(tipo) {
      // Verifica se o valor é uma string válida
      if (typeof tipo !== "string" || !tipo.trim()) return "status-false";

      // Normaliza o texto para comparação
      const key = tipo.trim().toUpperCase();

      // Mapeamento dos status para classes CSS
      const map = {
        // STATUS POSITIVOS
        CHEGADA_CONFIRMADA: "status-true",
        ALTA: "status-true",
        CONCLUIDA: "status-true",
        CONCLUIDA_EXTERNO: "status-true",
        INTERNADO: "status-true",

        // STATUS INTERMEDIÁRIOS / EM ANDAMENTO
        EM_FILA: "status-info",
        AGENDADA: "status-info",
        RESERVADO: "status-info",
        AGUARDANDO_AGENDAMENTO: "status-info",
        AGUARDANDO_CONFIRMACAO_RESERVA: "status-info",
        AGUARDANDO_OFERTA: "status-info",
        PENDENTE: "status-info",

        // STATUS NEGATIVOS / CANCELADOS / EXPIRADOS
        AUSENCIA_PACIENTE: "status-staging",
        DESAGENDADA: "status-false",
        CANCELADA: "status-false",
        EXPIRADA: "status-false",
      };

      // Retorna a classe correspondente ou padrão
      return map[key] || "status-false";
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("../../App.scss");
.uppercase {
  text-transform: uppercase;
}
</style>
